function initAccordion() {
  if ($('.accordion').length == 0) {
    return false;
  }

  $('.accordion').on('hidden.bs.collapse', function (e) {
    $(e.target).siblings('.accordion-item-heading').find('.accordion-item-button').addClass('accordion-item-button__collapsed');
  });

  $('.accordion').on('show.bs.collapse', function (e) {
    $(e.target).siblings('.accordion-item-heading').find('.accordion-item-button').removeClass('accordion-item-button__collapsed');
  });
}

export { initAccordion }



// WEBPACK FOOTER //
// ./scripts/modules/accordion.js